import { useState } from 'react'
import { filterBeds, getWardSummary } from '../utils/filters'

const useBedFilters = (bedsData) => {
  const [searchText, setSearchText] = useState('')
  const [wardFilter, setWardFilter] = useState('all')
  const [statusFilter, setStatusFilter] = useState('all')

  // Get unique wards for filter
  const wards = [...new Set(bedsData.map((bed) => bed.ward))].sort()

  // Get filtered beds data
  const filteredData = filterBeds(bedsData, searchText, wardFilter, statusFilter)

  // Get ward summary data
  const wardSummaryData = getWardSummary(bedsData, wards)

  return {
    searchText,
    setSearchText,
    wardFilter,
    setWardFilter,
    statusFilter,
    setStatusFilter,
    wards,
    filteredData,
    wardSummaryData
  }
}

export default useBedFilters
